import { Row, Col } from "react-bootstrap";
import { useImperativeHandle, forwardRef, useState, useEffect } from "react";
import defaultimg from "../../icons/noimage.png";
import { Action, Status, MessageTypes } from "../utility/common/constants/CommonConstants";
import { SingleInput } from "../utility/forms/inputs/InputsTransaction"
import { PQRHeader } from "./PQRObjects/PQRHeader";
import { PQRPage3TableColumnN } from "../utility/common/TransactionComponents/WPQ_PQR_Test_Table_Components";
import { AddUpdatePQRHeader } from "./PQRObjects/PQR_Validations";
import { validatePQRForm, validatePQRTestArrayEnhanced } from "./PQRObjects/PQR_ValidationConfig";
import { isAlphanumericMinusPlusPercent, SquareBracketNotAllowed, isAllowedDashedAmpersSpecialCharacters } from "../../functions/validations";
import { getAllUserMaster, IsUserMasterBand } from "../../Services/user-service";
import { emptyError } from "./PQRObjects/PQR_common";
import { handlePQRGeneralSubmit, handlePQRGeneralSubmitTemp } from "../utility/common/TransactionComponents/TransactionSubmitUtils";
import { DotLoader } from "react-spinners";
import { UnifiedSignatureSection } from "../utility/common/TransactionComponents/UnifiedSignatureSection";
import { fetchImagePreview } from "../utility/common/TransactionComponents/CommonImages";
import { showWarning } from "../utility/ui/notifications/Toaster";

const PQRTubesheetPage3 = forwardRef(
  (
    {
      headerObj,
      setheaderObj,
      detailObj,
      copydata,
      WPStype,
      action,
      setaction
    },
    ref
  ) => {
    const avatar = { defaultimg };
    const [users, setUsers] = useState(null);
    const folderwld = "wld_signatures";
    const sessionName = "PQRTubesheet";

    const [Tear_Test_Disabled, setTear_Test_Disabled] = useState(false);
    const [PullOut_Test_Disabled, setPullOut_Test_Disabled] = useState(false);
    const [PullOut_Test_Table_Disabled, setPullOut_Test_Table_Disabled] = useState(false);
    const [Hardness_Test_Disabled, setHardness_Test_Disabled] = useState(false);
    const [Radiography_Tests_Disabled, setRadiography_Tests_Disabled] = useState(false);
    const [Other_Test_Disabled, setOther_Test_Disabled] = useState(false);

    const [loading, setLoading] = useState(false);


    const [previewuser, setPreviewuser] = useState(avatar.defaultimg);
    const [previewapproved, setPreviewapproved] = useState(avatar.defaultimg);
    const [isEdited, setIsEdited] = useState(false);

    const Visual_Examination = headerObj?.Visual_Examination;
    const Liquid_Penetrant_Examination = headerObj?.Liquid_Penetrant_Examination;
    const Tear_Test = headerObj?.Tear_Test;
    const PullOut_Test = headerObj?.PullOut_Test;
    const Hardness_Test = headerObj?.Hardness_Test;
    const Radiography_Test = headerObj?.Radiography_Test;
    const Other_Test = headerObj?.Other_Test;
    const PullOut_Test_Table = headerObj?.PullOut_Test_Table;

    const fetchUserMaster = async () => {
      const result = await getAllUserMaster();
      const active = result.filter((item) => item.um_status === "Active");
      setUsers(active);
    };

    const [error, setError] = useState({
      PQR_Tear_TubeNo: {},
      PQR_Tear_Observation: {},
      PQR_Tear_Results: {},
      PQR_Tear_Notes: {},
      PQR_Tear_ReportNumHorizontal: {},
      PQR_PullOut_Location: {},
      PQR_PullOut_Load: {},
      PQR_PullOut_Fracture: {},

      PQR_PullOut_TubeNo: {},
      PQR_PullOut_Acceptance_Criteria: {},
      PQR_PullOut_Observation: {},
      PQR_PullOut_Results: {},
      PQR_PullOut_Notes: {},
      // PQR_PullOut_Calculation: {},
      PQR_PullOut_MinBreakLoad: {},
      PQR_PullOut_AreaTubeMaterial: {},
      PQR_PullOut_MinTensilStrength: {},
      PQR_PullOut_MinBreakStress: {},
      PQR_PullOut_FrValue: {},

      PQR_Radio_TubeNo: {},
      PQR_Radio_Acceptance_Criteria: {},
      PQR_Radio_Observation: {},
      PQR_Radio_Results: {},
      PQR_Radio_Notes: {},

      PQR_OT_TypeofTest: {},
      PQR_OT_Acceptance_Criteria: {},
      PQR_OT_Results: {},
      PQR_OT_Remarks: {},
      PQR_OT_Notes: {},



      PQR_HT_TypeofTest: {},
      PQR_HT_Tube_No: {},
      PQR_HT_BM_Tubesheet: {},
      PQR_HT_HAZ_Tubesheet: {},
      PQR_HT_Weld: {},
      PQR_HT_HAZ_Tube: {},
      PQR_HT_BM_Tube: {},
      PQR_HT_Results: {},
      PQR_HT_Notes: {},
      PQR_HT_ReportNumHorizontal: {},
      PQR_PullOut_AccCriteria_Notes: {},
      PQR_PullOut_ReportNumHorizontal: {},
      PQR_Radio_ReportNumHorizontal: {},

      WPSH_PreparedBy_Name: {},
      WPSH_PreparedBy_Date: {},
      WPSH_PreparedBy_Remark: {},

      WPSH_WitnessBy_Name: {},
      WPSH_ApprovedBy_Date: {},
      WPSH_Approval_Status: {},
      WPSH_ApprovedBy_Remark: {},
      WPSH_WeldingEnggBy_Date: {},
      WPSH_WeldingEnggBy_Name: {},
      WPSH_WeldingEnggBy: {},
      WPSH_WitnessBy_Date: {},
      WPSH_WitnessBy: {},
    });

    // Common function to check if test array has empty required fields
    const checkTestArrayDisabled = (testArray, requiredFields) => {

      if (!testArray) return false;
      const firstRow = testArray[0];
      if (!firstRow) return false;
      return requiredFields.some(field => firstRow[field] === "");
    };

    const disableTestrow = () => {
      const testConfigs = [
        { array: headerObj.Tear_Test, fields: ["PQR_Tear_TubeNo", "PQR_Tear_Observation", "PQR_Tear_Results"], setter: setTear_Test_Disabled },
        { array: headerObj.PullOut_Test, fields: ["PQR_PullOut_TubeNo", "PQR_PullOut_Location", "PQR_PullOut_Load", "PQR_PullOut_Fracture"], setter: setPullOut_Test_Disabled },
        { array: headerObj.PullOut_Test_Table, fields: ["PQR_PullOut_Acceptance_Criteria", "PQR_PullOut_Observation", "PQR_PullOut_Results"], setter: setPullOut_Test_Table_Disabled },
        { array: headerObj.Hardness_Test, fields: ["PQR_HT_TypeofTest", "PQR_HT_Tube_No", "PQR_HT_BM_Tubesheet", "PQR_HT_HAZ_Tubesheet", "PQR_HT_Weld", "PQR_HT_HAZ_Tube", "PQR_HT_BM_Tube", "PQR_HT_Results"], setter: setHardness_Test_Disabled },
        { array: headerObj.Radiography_Test, fields: ["PQR_Radio_TubeNo", "PQR_Radio_Acceptance_Criteria", "PQR_Radio_Observation", "PQR_Radio_Results"], setter: setRadiography_Tests_Disabled },
        { array: headerObj.Other_Test, fields: ["PQR_OT_TypeofTest", "PQR_OT_Acceptance_Criteria", "PQR_OT_Results", "PQR_OT_Remarks"], setter: setOther_Test_Disabled }
      ];

      testConfigs.forEach(({ array, fields, setter }) => {
        setter(checkTestArrayDisabled(array, fields));
      });
    }


    useEffect(() => {

      disableTestrow()

    }, [headerObj.Tear_Test, headerObj.PullOut_Test_Table, headerObj.Hardness_Test, headerObj.Radiography_Test, headerObj.Other_Test]);

    useEffect(() => {
      fetchUserMaster();


    }, []);


    const validate = async () => {
      // Use unified validation for tubesheet page 3
      const validationResult = validatePQRForm({
        headerObj,
        detailObj,
        WPStype: "Tubesheet",
        currentErrors: error,
        pageType: "tubesheet3",
        setError,
      });

      let isError = validationResult.isError;

      // Enhanced test array validations
      const testValidations = [
        validatePQRTestArrayEnhanced(Tear_Test, ["PQR_Tear_TubeNo", "PQR_Tear_Observation", "PQR_Tear_Results"], 1),
        validatePQRTestArrayEnhanced(PullOut_Test, ["PQR_PullOut_TubeNo", "PQR_PullOut_Location", "PQR_PullOut_Load", "PQR_PullOut_Fracture"], 1),
        validatePQRTestArrayEnhanced(PullOut_Test_Table, ["PQR_PullOut_Acceptance_Criteria", "PQR_PullOut_Observation", "PQR_PullOut_Results"], 1),
        validatePQRTestArrayEnhanced(Hardness_Test, ["PQR_HT_TypeofTest", "PQR_HT_Tube_No", "PQR_HT_BM_Tubesheet", "PQR_HT_HAZ_Tubesheet", "PQR_HT_Weld", "PQR_HT_HAZ_Tube", "PQR_HT_BM_Tube", "PQR_HT_Results"], 1),
        validatePQRTestArrayEnhanced(Radiography_Test, ["PQR_Radio_TubeNo", "PQR_Radio_Acceptance_Criteria", "PQR_Radio_Observation", "PQR_Radio_Results"], 1),
        validatePQRTestArrayEnhanced(Visual_Examination, ["PQR_VEX_WeldPass", "PQR_VEX_Acceptance_Criteria", "PQR_VEX_Observation", "PQR_VEX_Results"], 1),
        validatePQRTestArrayEnhanced(Liquid_Penetrant_Examination, ["PQR_LPEX_WeldPass", "PQR_LPEX_Acceptance_Criteria", "PQR_LPEX_Observation", "PQR_LPEX_Results"], 1),
        validatePQRTestArrayEnhanced(Other_Test, ["PQR_OT_TypeofTest", "PQR_OT_Acceptance_Criteria", "PQR_OT_Results", "PQR_OT_Remarks"], 1),
      ];

      // Check all test validations
      testValidations.forEach(result => {
        if (result.isError) {
          isError = true;
        }
      });

      // Check for additional error messages in test arrays
      for (let i = 0; i < 3; i++) {
        if (Visual_Examination[i] && Visual_Examination[i].errormessage !== "") {
          isError = true;
        }
        if (Liquid_Penetrant_Examination[i] && Liquid_Penetrant_Examination[i].errormessage !== "") {
          isError = true;
        }
      }

      return isError;
    };

    const handleAdd = async (approvalstatus, flag) => {
      let result = true;

      headerObj.WPSH_Status = approvalstatus;


      let TEAR = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        Tear_Test: headerObj.Tear_Test,
        tearCheck: headerObj.tearCheck,

      };
      let PULL = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PullOut_Test: headerObj.PullOut_Test,
        pullout_check: headerObj.pullout_check,

      };

      let PULL_Table = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PullOut_Test_Table: headerObj.PullOut_Test_Table,

      };
      let PULL_FIELDS = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        // PQR_PullOut_Calculation: headerObj.PQR_PullOut_Calculation,
        PQR_PullOut_MinBreakLoad: headerObj.PQR_PullOut_MinBreakLoad,
        PQR_PullOut_AreaTubeMaterial: headerObj.PQR_PullOut_AreaTubeMaterial,
        PQR_PullOut_MinTensilStrength: headerObj.PQR_PullOut_MinTensilStrength,
        PQR_PullOut_MinBreakStress: headerObj.PQR_PullOut_MinBreakStress,
        PQR_PullOut_FrValue: headerObj.PQR_PullOut_FrValue,
      };
      let HARD = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        Hardness_Test: headerObj.Hardness_Test,
        hardnessCheck: headerObj.hardnessCheck,
      };
      let RADIO = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        Radiography_Test: headerObj.Radiography_Test,
        radioCheck: headerObj.radioCheck,
      };

      let OTHER = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        Other_Test: headerObj.Other_Test,
        otherCheck: headerObj.otherCheck,
      };

      let PAGE3_NOTES = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_Tear_Notes: headerObj.PQR_Tear_Notes,
        PQR_Tear_ReportNumHorizontal: headerObj.PQR_Tear_ReportNumHorizontal,
        PQR_PullOut_Notes: headerObj.PQR_PullOut_Notes,
        PQR_HT_Notes: headerObj.PQR_HT_Notes,
        PQR_HT_ReportNumHorizontal: headerObj.PQR_HT_ReportNumHorizontal,
        PQR_PullOut_AccCriteria_Notes: headerObj.PQR_PullOut_AccCriteria_Notes,
        PQR_PullOut_ReportNumHorizontal: headerObj.PQR_PullOut_ReportNumHorizontal,
        PQR_Radio_Notes: headerObj.PQR_Radio_Notes,
        PQR_Radio_ReportNumHorizontal: headerObj.PQR_Radio_ReportNumHorizontal,
        PQR_OT_Notes: headerObj.PQR_OT_Notes,
      };




      const REMAIN = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        WPSH_PreparedBy_Remark: headerObj.WPSH_PreparedBy_Remark,
        WPSH_ApprovedBy_Remark: headerObj.WPSH_ApprovedBy_Remark,
        WPSH_WeldingEnggBy_Date: headerObj.WPSH_WeldingEnggBy_Date,
        WPSH_WeldingEnggBy_Name: headerObj.WPSH_WeldingEnggBy_Name || "",
        WPSH_WeldingEnggBy: headerObj.WPSH_WeldingEnggBy,
        WPSH_WitnessBy_Date: headerObj.WPSH_WitnessBy_Date,
        PQR_SignatureApproved: headerObj.PQR_SignatureApproved || "",
        WPSH_WitnessBy_Name: headerObj.WPSH_WitnessBy_Name || "",
        WPSH_ApprovedBy_Name: headerObj.WPSH_ApprovedBy_Name || "",
        WPSH_ApprovedBy_Date: headerObj.WPSH_ApprovedBy_Date,
        WPSH_WitnessBy: headerObj.WPSH_WitnessBy || "",
        WPSH_PreparedBy_Name: headerObj.WPSH_PreparedBy_Name,
        WPSH_PreparedBy_Date: headerObj.WPSH_PreparedBy_Date,
        PQR_SignaturePrepared: headerObj.PQR_SignaturePrepared || "",
        WPSH_PreparedBy: sessionStorage.getItem("User"),
        WPSH_Status: flag === "tempsave" ? Status.StatusTempSaved : Status.StatusFreezed,
        WPSH_Approval_Status: headerObj.WPSH_Approval_Status,
      };

      const postList = [
        TEAR,
        PULL,
        PULL_Table,
        PULL_FIELDS,
        HARD,
        RADIO,
        OTHER,
        PAGE3_NOTES,
        REMAIN,
      ];
      await AddUpdatePQRHeader(undefined, postList)
        .catch((e) => {
          result = false;
        })
        .then(async (r) => {
          if (r == MessageTypes.SpecialCharacters)
            result = MessageTypes.SpecialCharacters;
        });

      return Promise.resolve(result);
    };

    const checkIfUsernameExists = async () => {
      let res = await IsUserMasterBand();
      if (res !== undefined) return res.data.message;
      else return false;
    };



    const validateTemp = async () => {
      let isError = false;
      let temperror = emptyError(error, setError, isError);
      return { isError, temperror };
    };

    const handleSubmitTemp = () => handlePQRGeneralSubmitTemp(isEdited, validateTemp, (status) => handleAdd(status, "tempsave"), setLoading, setIsEdited, headerObj?.WPSH_Status);

    const handleSubmit = async () => {
      const isUsernamePresent = await checkIfUsernameExists();
      const status = !isUsernamePresent ? Status.StatusTempSaved : Status.StatusFreezed;

      const result = await handlePQRGeneralSubmit(validate, (s) => handleAdd(s, "freezed"), setLoading, status);

      if (result === MessageTypes.Required) {
        setTimeout(() => {
          if (action === Action.ActionAdd) {
            showWarning("Please Temp Save Data before leaving this Page")
          }
        }, 500);
        return MessageTypes.RequiredAll;
      }

      return result;
    };

    useImperativeHandle(ref, () => ({
      funcOnNext3: async () => {
        let res = false;
        res = await handleSubmit();
        return res;
      },

      funcOnNextTemp3: async () => {
        let res = false;
        res = await handleSubmitTemp();
        return res;
      },
    }));


    const handleChangeTearTestarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.Tear_Test[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);
      disableTestrow()
    };

    const handleChangePullTestarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.PullOut_Test[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);
      disableTestrow()
    };

    const handleChangePullTestTablearray = (Index, key, newValue) => {

      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.PullOut_Test_Table[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);
      disableTestrow()
    };

    const handleChangeHadnesstestarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.Hardness_Test[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);
      disableTestrow()
    };

    const handleChangetestarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.Radiography_Test[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);
      disableTestrow()
    };

    const handleChangeOther_Testarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.Other_Test[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);
      disableTestrow()
    };

    const handleChangeHeader = (e, i) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const { name, value } = e.target;
      setheaderObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const fetchbyuserprofile = async (userprofile) => {
      await fetchImagePreview(
        folderwld,
        userprofile,
        setPreviewuser,
        avatar.defaultimg
      );
    };

    const fetchapproveUserProfile = async (userprofile) => {
      await fetchImagePreview(
        folderwld,
        userprofile,
        setPreviewapproved,
        avatar.defaultimg
      );
    };

    useEffect(() => {
      if (action === Action.ActionEdit && headerObj?.PQR_SignaturePrepared !== "") {
        fetchbyuserprofile(headerObj?.PQR_SignaturePrepared);
      }

      if (action === Action.ActionEdit && headerObj?.PQR_SignatureApproved !== "") {
        fetchapproveUserProfile(headerObj?.PQR_SignatureApproved);
      }
    }, [headerObj?.PQR_SignatureApproved, headerObj?.PQR_SignaturePrepared]);


    const handleCheckboxChange = (e, field) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const isChecked = e.target.checked;
      setheaderObj((header) => ({
        ...header,
        [field]: isChecked ? "Yes" : "No",
      }));
    };




    return (
      <Row className="font">
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <PQRHeader headerObj={headerObj} WPStype={WPStype}></PQRHeader>

        <Row style={{ padding: "20px 60px" }}>
          <Row className="mb-1">
            <Col md={12}>

              <div className="checkboxproject">
                <input
                  style={{ position: "relative", bottom: "4px" }}
                  type="checkbox"
                  placeholder=" "
                  className="form-check-input"
                  id="chkcode"
                  onChange={(e) => handleCheckboxChange(e, "tearCheck")}
                  checked={headerObj?.tearCheck === "Yes"}

                />{" "}
                <span className="WPS-blue-text" style={{ position: "relative", bottom: "2px", left: "5px" }}>Tear Test</span>
              </div>
              {/* <p className="WPS-blue-text " style={{position:"relative", top:"10px"}}>Tear Test </p> */}

              <PQRPage3TableColumnN
                columns={3}
                sessionName={sessionName}
                maxLength={[30, 40, 30]}
                width={[245, 245, 245]}

                array={Tear_Test}
                setheaderObj={setheaderObj}
                setError={setError}
                allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                title={["Tube No.", "Observation", "Results"]}
                name={["PQR_Tear_TubeNo", "PQR_Tear_Observation", "PQR_Tear_Results"]}
                status={[error.PQR_Tear_TubeNo.status, error.PQR_Tear_Observation.status, error.PQR_Tear_Results.status]}
                message={[error.PQR_Tear_TubeNo.message, error.PQR_Tear_Observation.message, error.PQR_Tear_Results.message]}
                handleChangetestarray={handleChangeTearTestarray}
                // disabled={Tear_Test_Disabled}
                disabled={Tear_Test_Disabled}
                numberofrowsdisabled={1}
              />
            </Col>

            <Col md={12}>
              <SingleInput
                name="PQR_Tear_Notes"
                type="text"
                maxLength={80}
                status={error.PQR_Tear_Notes.status}
                value={headerObj?.PQR_Tear_Notes}
                onChange={handleChangeHeader}
                setError={setError}
                error={error}
                label="Notes"
                message={error.PQR_Tear_Notes.message}
                allowlistfunction={SquareBracketNotAllowed}
                allowcharacters="/%&\-"
                customMessage="Special Characters # $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>
            <Col md={12}>
              <SingleInput
                name="PQR_Tear_ReportNumHorizontal"
                type="text"
                maxLength={85}
                status={error.PQR_Tear_ReportNumHorizontal.status}
                value={headerObj?.PQR_Tear_ReportNumHorizontal}
                onChange={handleChangeHeader}
                label="Report Number"
                message={error.PQR_Tear_ReportNumHorizontal.message}
                setError={setError}
                error={error}
                allowlistfunction={SquareBracketNotAllowed}
                allowcharacters="/%&\-"
                customMessage="Special Characters # $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>
          </Row>
        </Row>

        <Row style={{ padding: "20px 60px" }} className="PQR-Page-row-padding">
          <Row className="mb-1">
            <Col md={12}>
              <div className="checkboxproject">
                <input
                  style={{ position: "relative", bottom: "4px" }}
                  type="checkbox"
                  placeholder=" "
                  className="form-check-input"
                  id="chkcode"
                  onChange={(e) => handleCheckboxChange(e, "pullout_check")}
                  checked={headerObj?.pullout_check === "Yes"}

                />{" "}
                <span className="WPS-blue-text" style={{ position: "relative", bottom: "2px", left: "5px" }}>Pull Out Test</span>
              </div>
              {/* <p className="WPS-blue-text " style={{position:"relative", top:"10px"}}>Pull Out Test </p> */}

              <PQRPage3TableColumnN
                columns={4}
                sessionName={sessionName}
                maxLength={[25, 20, 20, 25]}
                width={[245, 245, 245, 245]}

                array={PullOut_Test}
                setheaderObj={setheaderObj}
                setError={setError}
                allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                title={["Tube No.", "Location", "Load", "Fracture"]}
                name={["PQR_PullOut_TubeNo", "PQR_PullOut_Location", "PQR_PullOut_Load", "PQR_PullOut_Fracture"]}
                status={[error.PQR_PullOut_TubeNo.status, error.PQR_PullOut_Location.status, error.PQR_PullOut_Load.status, error.PQR_PullOut_Fracture.status]}
                message={[error.PQR_PullOut_TubeNo.message, error.PQR_PullOut_Location.message, error.PQR_PullOut_Load.message, error.PQR_PullOut_Fracture.message]}
                handleChangetestarray={handleChangePullTestarray}
                // disabled={PullOut_Test_Disabled}
                numberofrowsdisabled={1}
                disabled={PullOut_Test_Disabled}
              />
            </Col>

            <Col md={12}>
              <SingleInput

                name="PQR_PullOut_Notes"
                type="text"
                maxLength={80}
                status={error.PQR_PullOut_Notes.status}
                value={headerObj?.PQR_PullOut_Notes}
                onChange={handleChangeHeader}
                setError={setError}
                error={error}
                label="Notes"
                message={error.PQR_PullOut_Notes.message}
                allowlistfunction={SquareBracketNotAllowed}
                allowcharacters="/%&\-"
                customMessage="Special Characters # $ ' < > = ; not allowed"
              ></SingleInput>
                <SingleInput
                  name="PQR_PullOut_ReportNumHorizontal"
                  type="text"
                  maxLength={85}
                  status={error.PQR_PullOut_ReportNumHorizontal.status}
                  value={headerObj?.PQR_PullOut_ReportNumHorizontal}
                  onChange={handleChangeHeader}
                  label="Report Number"
                  message={error.PQR_PullOut_ReportNumHorizontal.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={SquareBracketNotAllowed}
                  allowcharacters="/%&\-"
                  customMessage="Special Characters # $ ' < > = ; not allowed"
                ></SingleInput>
              </Col>
            <p className="WPS-blue-text " style={{ position: "relative", top: "10px" }}>Calculation for Fr Value </p>


            <Col md={6}>
              <SingleInput

                name="PQR_PullOut_MinBreakLoad"
                type="text"
                maxLength={50}
                status={error.PQR_PullOut_MinBreakLoad.status}
                value={headerObj?.PQR_PullOut_MinBreakLoad}
                onChange={handleChangeHeader}
                setError={setError}
                error={error}
                label="Minimum Breaking Load(kN)"
                message={error.PQR_PullOut_MinBreakLoad.message}
                allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                allowcharacters="&-"
                customMessage="Special Characters # % + $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>

            <Col md={6}>
              <SingleInput

                name="PQR_PullOut_AreaTubeMaterial"
                type="text"
                maxLength={50}
                status={error.PQR_PullOut_AreaTubeMaterial.status}
                value={headerObj?.PQR_PullOut_AreaTubeMaterial}
                onChange={handleChangeHeader}
                label="Area of Tube Material(mm²)"
                message={error.PQR_PullOut_AreaTubeMaterial.message}
                setError={setError}
                error={error}
                allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                allowcharacters="&-"
                customMessage="Special Characters # % + $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>

            <Col md={12}>
              <SingleInput

                name="PQR_PullOut_MinTensilStrength"
                type="text"
                maxLength={50}
                status={error.PQR_PullOut_MinTensilStrength.status}
                value={headerObj?.PQR_PullOut_MinTensilStrength}
                onChange={handleChangeHeader}
                label="Minimum Specified Tensile Strength of Tube(MPa)"
                message={error.PQR_PullOut_MinTensilStrength.message}
                setError={setError}
                error={error}
                allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                allowcharacters="&-"
                customMessage="Special Characters # % + $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>

            <Col md={12}>
              <SingleInput

                name="PQR_PullOut_MinBreakStress"
                type="text"
                maxLength={50}
                status={error.PQR_PullOut_MinBreakStress.status}
                value={headerObj?.PQR_PullOut_MinBreakStress}
                onChange={handleChangeHeader}
                label="Minimum Breaking Stress( = Minimum Breaking Load in kN/Area of Tube Material in mm²)"
                message={error.PQR_PullOut_MinBreakStress.message}
                setError={setError}
                error={error}
                allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                allowcharacters="&-"
                customMessage="Special Characters # % + $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>

            <Col md={12}>
              <SingleInput

                name="PQR_PullOut_FrValue"
                type="text"
                maxLength={50}
                status={error.PQR_PullOut_FrValue.status}
                value={headerObj?.PQR_PullOut_FrValue}
                onChange={handleChangeHeader}
                label="Fr Value( = Minimum Breaking Stress/Minimum Tensile Strength of Tube)"
                message={error.PQR_PullOut_FrValue.message}
                setError={setError}
                error={error}
                allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                allowcharacters="&-"
                customMessage="Special Characters # % + $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>
          </Row>
          <Row style={{ padding: "1px 13px" }}>
            <Row className="mb-1">
              <Col md={12}>
                <PQRPage3TableColumnN
                  columns={3}
                  sessionName={sessionName}
                  maxLength={[30, 35, 30]}
                  width={[245, 245, 245]}

                  array={PullOut_Test_Table}
                  setheaderObj={setheaderObj}
                  setError={setError}
                  title={["Acceptance Criteria", "Observation", "Results"]}
                  name={["PQR_PullOut_Acceptance_Criteria", "PQR_PullOut_Observation", "PQR_PullOut_Results"]}
                  status={[error.PQR_PullOut_Acceptance_Criteria.status, error.PQR_PullOut_Observation.status, error.PQR_PullOut_Results.status]}
                  message={[error.PQR_PullOut_Acceptance_Criteria.message, error.PQR_PullOut_Observation.message, error.PQR_PullOut_Results.message]}
                  handleChangetestarray={handleChangePullTestTablearray}
                  allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                  disabled={PullOut_Test_Table_Disabled}
                  numberofrowsdisabled={1}

                  error={error}
                />
              </Col>
              <Col md={12}>
                <SingleInput
                  name="PQR_PullOut_AccCriteria_Notes"
                  type="text"
                  maxLength={100}
                  status={error.PQR_PullOut_AccCriteria_Notes.status}
                  value={headerObj?.PQR_PullOut_AccCriteria_Notes}
                  onChange={handleChangeHeader}
                  label="Notes"
                  message={error.PQR_PullOut_AccCriteria_Notes.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={SquareBracketNotAllowed}
                  allowcharacters="/%&\-"
                  customMessage="Special Characters # $ ' < > = ; not allowed"
                ></SingleInput>
              </Col>
            </Row>
          </Row>
        </Row>


        <Row style={{ padding: "20px 60px" }}>
          <Row className="mb-1">
            <Col md={12}>

              <div className="checkboxproject">
                <input
                  style={{ position: "relative", bottom: "4px" }}

                  type="checkbox"
                  placeholder=" "
                  className="form-check-input"
                  id="chkcode"
                  onChange={(e) => handleCheckboxChange(e, "hardnessCheck")}
                  checked={headerObj?.hardnessCheck === "Yes"}

                />{" "}
                <span className="WPS-blue-text" style={{ position: "relative", bottom: "2px", left: "5px" }}>Hardness Test </span>
              </div>
              {/* <p className="WPS-blue-text " style={{position:"relative", top:"10px"}}>Hardness Test </p> */}

              <PQRPage3TableColumnN
                columns={8}
                sessionName={sessionName}
                maxLength={[15, 12, 12, 12, 12, 12, 12, 15]}
                width={[125, 125, 125, 125]}

                array={Hardness_Test}
                setheaderObj={setheaderObj}
                setError={setError}
                allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                title={["Type", "Tube No", "BM-Tubesheet", "HAZ-Tubesheet", "Weld", "HAZ-Tube", "BM-Tube", "Results"]}
                name={["PQR_HT_TypeofTest", "PQR_HT_Tube_No", "PQR_HT_BM_Tubesheet", "PQR_HT_HAZ_Tubesheet", "PQR_HT_Weld", "PQR_HT_HAZ_Tube", "PQR_HT_BM_Tube", "PQR_HT_Results"]}
                status={[error.PQR_HT_TypeofTest.status, error.PQR_HT_Tube_No.status, error.PQR_HT_BM_Tubesheet.status, error.PQR_HT_HAZ_Tubesheet.status, error.PQR_HT_Weld.status, error.PQR_HT_HAZ_Tube.status, error.PQR_HT_BM_Tube.status, error.PQR_HT_Results.status]}
                message={[error.PQR_HT_TypeofTest.message, error.PQR_HT_Tube_No.message, error.PQR_HT_BM_Tubesheet.message, error.PQR_HT_HAZ_Tubesheet.message, error.PQR_HT_Weld.message, error.PQR_HT_HAZ_Tube.message, error.PQR_HT_BM_Tube.message, error.PQR_HT_Results.message]}
                handleChangetestarray={handleChangeHadnesstestarray}
                // disabled={Hardness_Test_Disabled}
                disabled={Hardness_Test_Disabled}
                numberofrowsdisabled={1}
              />
            </Col>

            <span className="WPS-blue-text" style={{ position: "relative", top: "10px" }}>Notes</span>
            <Col md={12}>
              <SingleInput

                name="PQR_HT_Notes"
                type="text"
                maxLength={80}
                status={error.PQR_HT_Notes.status}
                value={headerObj?.PQR_HT_Notes}
                onChange={handleChangeHeader}
                label="Notes"
                message={error.PQR_HT_Notes.message}
                setError={setError}
                error={error}
                allowlistfunction={SquareBracketNotAllowed}
                allowcharacters="/%&\-"
                customMessage="Special Characters # $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>
            <Col md={12}>
              <SingleInput
                name="PQR_HT_ReportNumHorizontal"
                type="text"
                maxLength={85}
                status={error.PQR_HT_ReportNumHorizontal.status}
                value={headerObj?.PQR_HT_ReportNumHorizontal}
                onChange={handleChangeHeader}
                label="Report Number"
                message={error.PQR_HT_ReportNumHorizontal.message}
                setError={setError}
                error={error}
                allowlistfunction={SquareBracketNotAllowed}
                allowcharacters="/%&\-"
                customMessage="Special Characters other than # [ ' < > = ; not allowed"
              ></SingleInput>
            </Col>
          </Row>
        </Row>

        <Row style={{ padding: "20px 60px" }} className="PQR-Page-row-padding">
          <Row className="mb-1">
            <Col md={12}>

              <div className="checkboxproject">
                <input
                  style={{ position: "relative", bottom: "4px" }}
                  type="checkbox"
                  placeholder=" "
                  className="form-check-input"
                  id="chkcode"
                  onChange={(e) => handleCheckboxChange(e, "radioCheck")}
                  checked={headerObj?.radioCheck === "Yes"}

                />{" "}
                <span className="WPS-blue-text" style={{ position: "relative", bottom: "2px", left: "5px" }}>Radiography Test </span>
              </div>
              {/* <p className="WPS-blue-text " style={{position:"relative", top:"10px"}}>Radiography Test </p> */}

              <PQRPage3TableColumnN
                columns={4}
                sessionName={sessionName}
                maxLength={[25, 25, 25, 25]}
                width={[245, 245, 245, 245]}

                array={Radiography_Test}
                setheaderObj={setheaderObj}
                setError={setError}
                allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                title={["Tube No.", "Acceptance Criteria", "Observation", "Results"]}
                name={["PQR_Radio_TubeNo", "PQR_Radio_Acceptance_Criteria", "PQR_Radio_Observation", "PQR_Radio_Results"]}
                status={[error.PQR_Radio_TubeNo.status, error.PQR_Radio_Acceptance_Criteria.status, error.PQR_Radio_Observation.status, error.PQR_Radio_Results.status]}
                message={[error.PQR_Radio_TubeNo.message, error.PQR_Radio_Acceptance_Criteria.message, error.PQR_Radio_Observation.message, error.PQR_Radio_Results.message]}
                handleChangetestarray={handleChangetestarray}

                disabled={Radiography_Tests_Disabled}
                numberofrowsdisabled={1}
              />
            </Col>

            <Col md={12}>
              <SingleInput

                name="PQR_Radio_Notes"
                type="text"
                maxLength={80}
                status={error.PQR_Radio_Notes.status}
                value={headerObj?.PQR_Radio_Notes}
                onChange={handleChangeHeader}
                label="Notes"
                message={error.PQR_Radio_Notes.message}
                setError={setError}
                error={error}
                allowlistfunction={SquareBracketNotAllowed}
                allowcharacters="/%&\-"
                customMessage="Special Characters # $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>
            <Col md={12}>
              <SingleInput
                name="PQR_Radio_ReportNumHorizontal"
                type="text"
                maxLength={85}
                status={error.PQR_Radio_ReportNumHorizontal.status}
                value={headerObj?.PQR_Radio_ReportNumHorizontal}
                onChange={handleChangeHeader}
                label="Report Number"
                message={error.PQR_Radio_ReportNumHorizontal.message}
                setError={setError}
                error={error}
                allowlistfunction={SquareBracketNotAllowed}
                allowcharacters="/%&\-"
                customMessage="Special Characters # $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>
          </Row>
        </Row>

        <Row style={{ padding: "20px 60px" }}>
          <Row className="mb-1">
            <Col md={12}>

              <div className="checkboxproject">
                <input
                  style={{ position: "relative", bottom: "4px" }}
                  type="checkbox"
                  placeholder=" "
                  className="form-check-input"
                  id="chkcode"
                  onChange={(e) => handleCheckboxChange(e, "otherCheck")}
                  checked={headerObj?.otherCheck === "Yes"}

                />{" "}
                <span className="WPS-blue-text" style={{ position: "relative", bottom: "2px", left: "5px" }}>Other Test </span>
              </div>
              <PQRPage3TableColumnN
                columns={4}
                sessionName={sessionName}
                maxLength={[25, 25, 25, 25]}
                width={[245, 245, 245, 245]}
                array={Other_Test}
                setheaderObj={setheaderObj}
                setError={setError}
                allowlistfunction={isAllowedDashedAmpersSpecialCharacters}
                title={["Type of Test", "Acceptance Criteria", "Results", "Remarks"]}
                name={["PQR_OT_TypeofTest", "PQR_OT_Acceptance_Criteria", "PQR_OT_Results", "PQR_OT_Remarks"]}
                status={[error.PQR_OT_TypeofTest.status, error.PQR_OT_Acceptance_Criteria.status, error.PQR_OT_Results.status, error.PQR_OT_Remarks.status]}
                message={[error.PQR_OT_TypeofTest.message, error.PQR_OT_Acceptance_Criteria.message, error.PQR_OT_Results.message, error.PQR_OT_Remarks.message]}
                handleChangetestarray={handleChangeOther_Testarray}
                disabled={Other_Test_Disabled}
                numberofrowsdisabled={1}
              />
            </Col>
            <Col md={12}>
              <SingleInput

                name="PQR_OT_Notes"
                type="text"
                maxLength={100}
                status={error.PQR_OT_Notes.status}
                value={headerObj?.PQR_OT_Notes}
                onChange={handleChangeHeader}
                label="Notes"
                message={error.PQR_OT_Notes.message}
                setError={setError}
                error={error}
              ></SingleInput>
            </Col>
          </Row>
        </Row>

        {/* -------------------------signature sections (unified component)---------------------------- */}
        <UnifiedSignatureSection
          sessionType="PQR"
          sectionType="combined"
          headerObj={headerObj}
          setheaderObj={setheaderObj}
          users={users}
          error={error}
          setError={setError}
          previewImage={previewuser}
          previewApprovedImage={previewapproved}
          fetchUserProfile={fetchbyuserprofile}
          fetchApprovedUserProfile={fetchapproveUserProfile}
          isReadonly={copydata}
          action={action}
          setIsEdited={setIsEdited}
        />
      </Row>
    );
  }
);

export default PQRTubesheetPage3;
